import isUndefined from 'lodash/isUndefined'

function canDownload() {
  return !isUndefined(document.createElement('a').download)
}

export default canDownload
